const ReportTemplateReformatCopyData = (listRawData) => {
  const _list = [];
  for (let rawData of listRawData) {
    const row = {};

    row["product_name"] = rawData.product_name;
    row["customer_code"] = rawData.customer_code;
    row["customer_name"] = rawData.customer_name;
    row["bc_name"] = rawData.bc_name;
    row["price"] = rawData.price;
    row["quantity"] = rawData.quantity;
    row["expired_date"] = rawData.expired_date;
    row["transaction_date"] = rawData.transaction_date;
    row["sales_number"] = rawData.sales_number;

    _list.push(row);
  }

  return _list;
};

export default ReportTemplateReformatCopyData;
